import React from 'react';
import { Card, CardContent } from './ui/card';
import { ExternalLink, Code } from 'lucide-react';

const Portfolio = () => {
  const projects = [
    {
      title: 'E-Commerce Platform',
      description: 'Modern online store with shopping cart, payment integration, and admin dashboard.',
      tech: ['React', 'Python', 'MongoDB'],
      image: 'https://images.unsplash.com/photo-1557821552-17105176677c?w=800&q=80',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      title: 'Corporate Website',
      description: 'Professional business website with CMS, blog, and contact forms.',
      tech: ['Angular', 'Python', 'PostgreSQL'],
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
      color: 'from-indigo-500 to-violet-500'
    },
    {
      title: 'Real Estate Portal',
      description: 'Property listing platform with advanced search and virtual tours.',
      tech: ['React', 'Python', 'MySQL'],
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
      color: 'from-orange-500 to-red-500'
    },
    {
      title: 'Healthcare Dashboard',
      description: 'Patient management system with appointment scheduling and analytics.',
      tech: ['Angular', 'Python', 'MongoDB'],
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
      color: 'from-green-500 to-emerald-500'
    },
    {
      title: 'Educational Platform',
      description: 'Online learning platform with video courses and progress tracking.',
      tech: ['React', 'Python', 'Firebase'],
      image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&q=80',
      color: 'from-indigo-500 to-blue-500'
    },
    {
      title: 'Restaurant Booking App',
      description: 'Table reservation system with menu display and customer reviews.',
      tech: ['Angular', 'Python', 'PostgreSQL'],
      image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80',
      color: 'from-yellow-500 to-orange-500'
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="text-blue-600">Portfolio</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Showcasing our recent projects and successful client collaborations
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <Card
              key={index}
              className="group overflow-hidden border-0 bg-slate-50 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-20 group-hover:opacity-30 transition-opacity duration-300`}></div>
                <div className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg">
                  <ExternalLink className="w-5 h-5 text-slate-700" />
                </div>
              </div>
              
              <CardContent className="p-6">
                <h3 className="text-2xl font-semibold text-slate-900 mb-3">{project.title}</h3>
                <p className="text-slate-600 mb-4 leading-relaxed">{project.description}</p>
                
                <div className="flex flex-wrap gap-2">
                  {project.tech.map((tech, techIndex) => (
                    <span
                      key={techIndex}
                      className="inline-flex items-center gap-1 px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-medium"
                    >
                      <Code className="w-3 h-3" />
                      {tech}
                    </span>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;